import { DpProductCardDescription } from '@/components/blocks/DpProductCardDescription';
import { ContentRecommendation } from '@/components/content/ContentRecommendation';
import { Skeleton } from '@mui/material';

interface ProductCardBundlePriceContentRecommendationProps {
	partNumber: string;
	name: string;
	manufacturer: string;
	discount?: string | null;
	price?: string | null;
}

export const ProductCardBundlePriceContentRecommendation: React.FC<
	ProductCardBundlePriceContentRecommendationProps
> = ({ partNumber, name, manufacturer, discount, price }) => {
	const ems = `DPV2BundleProductCardDescription_${partNumber}`;
	return (
		<ContentRecommendation
			id={ems}
			properties={{ emsName: ems }}
			withoutFrame
			emptyElement={
				<DpProductCardDescription
					name={name}
					manufacturer={manufacturer ?? 'Combo'}
					discount={discount}
					price={price}
				/>
			}
			loadingElement={
				<>
					<Skeleton variant="rounded" width="80%" height="74px" />
					<Skeleton variant="rounded" width="80%" height="24px" />
				</>
			}
		/>
	);
};
